<template>
  <content-container
      class="fh-area fh-container"
      :overlay="loading"
      no-bottom-margin
      :container="false"
  >
    <b-container v-if="items.current && items.current.data" class="fh-area">
      <!-- === Навигатор ================================================== -->
      <div class="licenses-nav d-flex justify-content-between mb-4">
        <b-nav class="editor">
          <template v-if="items.all && items.all.length > 1">
            <b-nav-item-dropdown
                id="my-nav-dropdown"
                :text="getLicenseName(items.current.data)"
                toggle-class="nav-link-custom text-wrap"
                right
                active
            >
              <template v-for="(group, group_index) in items.sortedList">
                <b-dropdown-divider
                    v-if="group_index"
                    :key="group_index + '_' + group.label"
                ></b-dropdown-divider>
                <b-dropdown-text class="group-name text-nowrap" :key="group.label">{{
                    group.label
                  }}
                </b-dropdown-text>
                <b-dropdown-item
                    v-for="item in group.options"
                    :key="item.id"
                    :active="item.value == items.current.data.id"
                    @click="onLicenseSelected($event, items.current, item.value)"
                >{{ item.text }}
                </b-dropdown-item
                >
              </template>
            </b-nav-item-dropdown>
          </template>
          <template v-else>
            <b-nav-text>{{ getLicenseName(items.current.data) }}</b-nav-text>
          </template>
        </b-nav>
      </div>
      <!-- === Начинка ================================================== -->

      <b-container class="pl-0 pr-0 mb-5">
        <!--
                <dev-only>
                  <div v-if="$store.state.dev.visible" class="debug-panel border mb-3">
                    <pre>{{ JSON.stringify(items.current, null, 4) }} <hr/> <div class="history">{{JSON.stringify(items.history, null, 4) }}</div></pre>
                    <div
                      class="
                        pt-1
                        pb-1
                        pl-2
                        pr-2
                        bg-light
                        d-flex
                        justify-content-between
                      "
                    >
                      <div>Changed: {{ items.current.data.isChanged() }}</div>
                      <b-checkbox v-model="dev_visible">Показывать отладку</b-checkbox>
                    </div>
                  </div>
                  <div v-if="!$store.state.dev.visible" class="debug-enabler">
                    <b-button
                      variant="outline-secondary"
                      size="sm"
                      :pressed.sync="dev_visible"
                      >D</b-button
                    >
                  </div>
                </dev-only>
        -->
        <!-- === Название, описание ======= -->
        <div class="name-desc mb-5">
          <b-row>
            <b-col>
              <!--
                <b-form-group
                  label-cols="false"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  label-align="left"
                  label-align-sm="right"
                  label="UUID:"
                  label-for="license-id"
                >
                  <div id="license-id" class="">
                    {{ items.current.data.id }}
                  </div>
                </b-form-group>
  -->

              <b-form-group
                  label-cols="false"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  label-align="left"
                  label-align-sm="right"
                  label="Name:"
                  label-for="input-name"
              >
                <b-form-input
                    id="input-name"
                    placeholder="License name (optional)"
                    v-model="items.current.data.name"
                    @update="updateNavTextForItem(items.current.data)"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                  label-cols="false"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  label-align="left"
                  label-align-sm="right"
                  label="Description:"
                  label-for="input-desc"
              >
                <b-form-input
                    id="input-desc"
                    placeholder="License description (optional)"
                    v-model="items.current.data.description"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <!-- === Соединения ======= -->
        <div>
          <transition-group name="fade">
            <b-row
                class="slot mb-5"
                v-for="(conn, conn_idx) in items.current.data.connections"
                :key="conn.id"
            >
              <b-col cols="12">
                <connection-view
                    :ref="'slot_'+conn_idx"
                    :license="items.current"
                    :conn="conn"
                    :conn_idx="conn_idx"
                    @focus-last-entity="handleFocusLastEntity"
                    @add-new-slot="handleAddSlotClick(items.current)"
                ></connection-view>
              </b-col>
            </b-row>
          </transition-group>
        </div>
        <!--
                <div class="buttons mb-5">
                  <b-button
                    v-if="canAddNewSlot()"
                    variant="primary"
                    @click="handleAddSlotClick(items.current)"
                  >
                    <b-icon-plus aria-hidden="true" class="mr-1"></b-icon-plus>{{ $t('license.editor.add_slot') }}
                  </b-button>
                </div>
        -->

      </b-container>
    </b-container>

    <!-- === Подсказка про триал и общий итог ============================= -->
    <b-container v-if="showTrialNote() || totalSum()" class="mb-5 separated">
      <!-- Подсказка про триал на месяц -->
      <collapsible-card
          id="trial-note"
          v-if="showTrialNote()"
          :collapsible="false"
      >
        <template v-slot:description>
          <div class="d-flex flex-row">
            <div class="icon center-both">
              <b-icon-gift scale="2"></b-icon-gift>
            </div>
            <div class="text-secondary">{{ $t('license.editor.trial-note.note') }} <span
                :class="[moreThanFiveNames() ? 'text-dark font-weight-bold fadeIn' : 'text-secondary']">{{
                $t('license.editor.trial-note.condition1')
              }}</span> {{ $t('license.editor.trial-note.glue') }} <span
                :class="[hasWildcards() ? 'text-dark font-weight-bold fadeIn' : 'text-secondary']">{{
                $t('license.editor.trial-note.condition2')
              }}</span>.
            </div>
          </div>
        </template>
      </collapsible-card>

      <!-- === Общий ИТОГ =================================== -->
      <div v-if="totalSum()" class="total-price">
        <div class="text">{{ $t('license.editor.total') }} <span
            class="text-secondary">{{ $t('license.editor.without_tax') }}</span>:
        </div>
        <div class="price text-right">${{ totalSum() }}</div>
      </div>
    </b-container>

    <div
        id="action-bar"
        v-if="
        this.items.current &&
        (canDelete() || canDownload() || canPay() || canSave())
      "
    >
      <b-container v-if="items.current && items.current.data">
        <div class="license-actions pt-5 pb-5">
          <b-button
              v-if="canDelete()"
              variant="outline-danger"
              :disabled="!items.current.canDelete()"
              @click="handleDeleteLicenseClick(items.current.data)"
              class="mr-sm-3"
          >
            <b-icon-trash-fill></b-icon-trash-fill>
            <span class="text">{{ $t('license.editor.delete') }}</span>
          </b-button>

          <div class="separator"></div>

          <b-button
              v-if="canPay()"
              class="mr-3"
              variant="primary"
              :disabled="!canProceedPayment()"
              @click="handlePayLicenseClick()"
          >
            <b-icon-credit-card-fill></b-icon-credit-card-fill>
            <span class="text">{{ $t('license.editor.pay') }}</span>
          </b-button>

          <b-button
              v-if="canDownload()"
              class="mr-3"
              :variant="
              items.current.data.encrypt ? 'outline-primary' : 'primary'
            "
              :disabled="!canProceedDownload()"
              @click="handleDownloadLicenseClick(items.current.data)"
          >
            <b-icon-cloud-download-fill></b-icon-cloud-download-fill>
            <span class="text">{{ $t('license.editor.download') }}</span>
          </b-button>

          <b-button
              v-if="canSave()"
              variant="primary"
              :disabled="!canProceedSave()"
              @click="handleSaveLicenseClick(items.current.data)"
              :class="{ 'shadow-blink': canProceedSave() && items.current.data._new }"
          >
            <b-icon-cloud-upload-fill></b-icon-cloud-upload-fill>
            <span class="text">{{ $t('license.editor.save') }}</span>
          </b-button>
        </div>
      </b-container>
    </div>
    <pay-license-modal
        :licenseWrapper="this.items.current"
        v-on:item-saved="handleSavedInPayModal"
    ></pay-license-modal>
    <save-license-modal
        :licenseWrapper="this.items.current"
        v-on:save-draft="savePersistentLicense"
        v-on:encrypted-saved="handleEncryptedLicenseSaved"
        v-on:pay-license="handlePayLicenseEvent"
    ></save-license-modal>
    <payment-ok-modal :licenseWrapper="this.items.current"></payment-ok-modal>
    <payment-cancel-modal :licenseWrapper="this.items.current"></payment-cancel-modal>
  </content-container>
</template>

<script>
import i18n from "@/i18n";
import ContentContainer from "@/components/ContentContainer";
import {
  //BIconPlus,
  BIconCreditCardFill,
  BIconCloudDownloadFill,
  BIconCloudUploadFill,
  BIconTrashFill,
  BIconGift
} from "bootstrap-vue";
import PayLicenseModal from "./PayLicenseModal.vue";
import {
  isUnsavedId,
  isPersonalTrial,
  licenseObject,
  UNSAVED_LICENSE_ID,
  getUnpaid,
  getActive,
  getArchive,
  getLicenseName,
  conNotEmptyAndValid,
  canDelete,
  canPay,
  canDownload,
  canSave,
  isConNonPersonalTrial,
  somethingAwaitingPayment,
  findEntityType,
  conSummaryVisible, isNonPersonalTrial, localNames, entIsWildcard, WILDCARD, isDraft
} from "@/components/rdbm/license.js";
import {URL_DELETE_LICENSE, URL_LOAD_LICENSE} from "@/globals";
//import DevOnly from "../../DevOnly.vue";
import SaveLicenseModal from "./SaveLicenseModal.vue";
import {toRequestObj} from "@/components/rdbm/license.js";
import CollapsibleCard from "../../CollapsibleCard.vue";
import {
  URL_SAVE_LICENSE,
  URL_UPDATE_LICENSE,
  URL_DOWNLOAD_LICENSE,
} from "@/globals";
import ConnectionView from "./ConnectionView.vue";
import {saveAs} from "file-saver";
import PaymentOkModal from "@/components/user-dashboard/rdbm/PaymentOkModal";
import PaymentCancelModal from "@/components/user-dashboard/rdbm/PaymentCancelModal";

// Позволяет сделать кнопки Оплатить и Скачать активными до сохранения лицензии,
// те будет автоматически вызвано сохранение перед этими действиями.
const SAVE_BEFORE_ACTION = false;

export default {
  name: "UserRDBMLicenseEditor",
  components: {
    PaymentOkModal,
    PaymentCancelModal,
    //BIconPlus,
    BIconCreditCardFill,
    BIconCloudDownloadFill,
    BIconTrashFill,
    BIconCloudUploadFill,
    BIconGift,
    PayLicenseModal,
    ContentContainer,
    //DevOnly,
    SaveLicenseModal,
    ConnectionView,
    CollapsibleCard
  },
  props: ["id", "extItem", "extLicenses", "action", "special"],
  data() {
    return {
      items: {
        all: [],
        current: null,
        sortedList: [],
        selected: null,
        history: [],
      },
      loading: false,
      doNotLoadItem: false,
      was_wild: false
    };
  },
  computed: {
    dev_visible: {
      get() {
        return this.$store.state.dev.visible;
      },
      set(value) {
        this.$store.commit("setVisible", value);
      },
    },
  },
  methods: {
    showTrialNote: function () {
      return (this.items.current && this.items.current.data &&
          (this.items.current.data._new || isDraft(this.items.current.data)) && (!this.special || this.special.type == "none"))
    },
    hasWildcards: function () {
      let count = 0;
      if (this.items.current && this.items.current.data) {
        let i = 0;
        while (i < this.items.current.data.connections.length) {
          let conn = this.items.current.data.connections[i];
          let j = 0;
          while (j < conn.entities.length) {
            if (entIsWildcard(conn.entities[j])) {
              count++;
            }
            j++;
          }
          i++;
        }
      }
      return count >= 1;
    },
    moreThanFiveNames: function () {
      let count = 0;
      if (this.items.current && this.items.current.data) {
        for (let c of this.items.current.data.connections) {
          for (let i = 0; i < c.entities.length; i++) {
            count++;
          }
        }
      }
      return count > 5;
    },
    totalSum: function () {
      let result = 0;
      if (this.items.current && this.items.current.data) {
        for (let c of this.items.current.data.connections) {
          if (conSummaryVisible(c) && c._summary.items && c._summary.items.length > 0) result += c._summary.price;
        }
      }
      return result;
    },
    canDelete: function () {
      return canDelete(this.items.current.data);
    },
    canPay: function () {
      return canPay(this.items.current.data);
    },
    canProceedPayment: function () {
      let corp_locals = isNonPersonalTrial(this.items.current.data) &&
          this.items.current.data.connections.length == 1 &&
          this.items.current.data.connections[0].entities.length == 0;
      let notEmptyAndValid = this.items.current.data.connections.every((con) =>
          conNotEmptyAndValid(con)
      );
      return (
          corp_locals || (
              notEmptyAndValid &&
              somethingAwaitingPayment(this.items.current.data) &&
              (!this.items.current.data.isChanged() || SAVE_BEFORE_ACTION)
          ));
    },
    canDownload: function () {
      return canDownload(this.items.current.data);
    },
    canProceedDownload: function () {
      let notEmptyAndValid = this.items.current.data.connections.every((con) =>
          conNotEmptyAndValid(con)
      );
      return (
          // Не пустая (те не триал для локальных имен)
          (notEmptyAndValid && (!this.items.current.data.isChanged() || SAVE_BEFORE_ACTION)) ||
          // Триал для локальных имен тоже можно скачать
          localNames(this.items.current.data)
      );
    },
    canProceedSave: function () {
      return this.items.current.isChangedAndValid() ||
          (this.items.current.data._new && (isPersonalTrial(this.items.current.data) || isNonPersonalTrial(this.items.current.data)));
    },
    canSave: function () {
      return canSave(this.items.current.data);
    },
    canAddNewSlot: function () {
      // Всегда кроме персонального триалла и его аналога для бизнеса, попробую проще: если первый слот не пустой
      return this.items.current.data.connections && this.items.current.data.connections.length > 0 &&
          this.items.current.data.connections.find(c => c.entities.length > 0);
    },
    navigateToId: function (new_id, replace = false, doNotLoadItem = false) {
      this.doNotLoadItem = doNotLoadItem;
      try {
        if (replace) {
          this.$router.replace({
            name: "rdbmItem",
            params: {
              id: new_id,
            },
          });
        } else {
          this.$router.push({
            name: "rdbmItem",
            params: {
              id: new_id,
            },
          });
        }
      } finally {
        this.doNotLoadItem = false;
      }
    },
    updateNavTextForItem: function (item) {
      for (const group of this.items.sortedList) {
        let found = group.options.find((i) => i.value == item.id);
        if (found) {
          this.$set(found, "text", getLicenseName(item));
        }
      }
      let found = this.items.all.find((i) => i.id == item.id);
      if (found) this.$set(found, "name", getLicenseName(item));
    },
    arrangeLicenses: function (list) {
      let result = [];
      let part = getUnpaid(list);
      if (part.length)
        result.push({
          label: this.$t('license.list.can_pay'),
          options: part.map((item) => ({
            value: item.id,
            text: getLicenseName(item),
          })),
        });
      part = getActive(list);
      if (part.length)
        result.push({
          label: this.$t('license.list.active'),
          options: part.map((item) => ({
            value: item.id,
            text: getLicenseName(item),
          })),
        });
      part = getArchive(list);
      if (part.length)
        result.push({
          label: this.$t('license.list.archive'),
          options: part.map((item) => ({
            value: item.id,
            text: getLicenseName(item),
          })),
        });
      return result;
    },
    getLicenseName: function (license) {
      return getLicenseName(license);
    },
    // Подтверждение потери данных. Два режима: несохраненные изменения и пустая только что созданная сущьность
    askIgnoreChangesDestroyingNew(current, selected_id) {
      let remove_id = current.data._new ? current.id : null;
      this.$bvModal
          .msgBoxConfirm(
              current.data.isChanged()
                  ? this.$t('license.editor.leave_unsaved.changes_loss')
                  : this.$t('license.editor.leave_unsaved.draft_loss'),
              msgBoxOptions(this.$t('license.editor.leave_unsaved.h'))
          )
          .then((value) => {
            if (value) {
              this._set_current_by_id(selected_id);
              this.removeItemById(remove_id);
              this.navigateToId(selected_id);
            }
          })
          .catch(() => {
            // An error occurred
          });
    },
    onLicenseSelected: function (event, current, selected_id) {
      if (current.data.isChanged() || current.data._new) {
        // Можно ли игнорировать не сохраненное? Включая измененный новый набросок (еще не сохраненный)
        this.askIgnoreChangesDestroyingNew(current, selected_id);
      } else {
        // Набросок не изменился, простое переключение.
        if (selected_id != this.items.current.data.id) {
          this.navigateToId(selected_id);
          //this.loadOne(selected_id);
        }
      }
      event.preventDefault();
    },
    handleCreateClick: function () {
      this.addOrReplaceNew();
    },
    handleFocusLastEntity: function () {
      let slot = this.$refs["slot_" + (this.items.current.data.connections.length - 1)];
      let entity = slot[0].$refs.entity_0;
      entity[0].$refs.type.$el.focus();
    },
    handleAddSlotClick: function () {
      this.items.current.addSlot();
      //this.items.current.validate();
    },
    handleDeleteLicenseClick: function (license) {
      const h = this.$createElement

      const messageVNode = h('div', {}, [
        h('p', {domProps: {innerHTML: this.$t('license.delete.msg')}}),
        h('p', {domProps: {innerHTML: this.$t('license.delete.q')}})
      ]);
      this.$bvModal
          .msgBoxConfirm([messageVNode],
              msgBoxOptions(
                  this.$t('license.delete.h')
              )
          )
          .then((value) => {
            if (value) {
              this.$http_delete(URL_DELETE_LICENSE + license.id, {}, true)
                  .then(() => {
                    this.$router.go(-1);
                  })
                  .catch((error) => {
                    this.$alert.show(error);
                  });
            }
          })
          .catch(() => {
            // An error occurred
          });
    },
    handleDownloadLicenseClick: function (license) {
      if (license.isChanged()) this.handleSaveLicenseClick(license);

      if (license.encrypt) {
        // Показываем подсказку
        this.$bvModal.show("save-license-modal");
      } else {
        this.$post(
            URL_DOWNLOAD_LICENSE.format(license.id),
            toRequestObj(license),
            true,
            true,
            true
        )
            .then((result) => {
              // Скачка через механизм HTML5
              var byteString = atob(result.image);
              var ab = new ArrayBuffer(byteString.length);
              var ia = new Uint8Array(ab);

              for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
              }

              let blob = new Blob([ab], {type: "text/plain;charset=utf-8"});
              saveAs(blob, "rdbm-" + result.license.id + ".license");

              this._set_current(result.license);
              //this.navigateToId(result.license.id, true, true);
              this.completed = true;
            })
            .catch((error) => {
              this.$alert.show(error);
              this.loading = false;
            });
      }
    },
    handleEncryptedLicenseSaved: function () {
      this.navigateToId(this.items.current.data.id, true, true);
    },
    handlePayLicenseEvent: function () {
      this.handlePayLicenseClick();
    },
    handlePayLicenseClick: function () {
      this.$bvModal.show("pay-license-modal");
    },
    handleSavedInPayModal: function (result) {
      this._set_current(result);
    },
    handleSaveLicenseClick: function (license) {
      if (license._new) {
        this.$bvModal.show("save-license-modal");
      } else {
        // Если в триал добавить "звезду" он перестанет быть триалом.
        if (license.connections.find(c => isConNonPersonalTrial(c) && c.entities.find((e) => findEntityType(e).wild))) {
          const h = this.$createElement;
          const messageVNode = h("div", {}, [
            h("p", {}, [
              this.$t('license.editor.wildcard_in_trial.msg_h'),
            ]),
            h("p", {}, [this.$t('license.editor.wildcard_in_trial.msg')]),
            h("div", {}, [this.$t('license.editor.wildcard_in_trial.q')]),
          ]);
          this.$bvModal
              .msgBoxConfirm([messageVNode], msgBoxOptions(this.$t('license.editor.wildcard_in_trial.h')))
              .then((value) => {
                if (value) this.savePersistentLicense();
              });
        } else {
          this.savePersistentLicense();
        }
      }
    },
    // Сохранение лицензии либо УЖЕ существующей в базе, либо новой не шифрованной
    savePersistentLicense: function () {
      if (this.items.current.data._new) {
        this.$post(
            URL_SAVE_LICENSE,
            toRequestObj(this.items.current.data),
            true
        )
            .then((result) => {
              this._set_current(result);
              this.navigateToId(result.id, true, true);
            })
            .catch((error) => {
              this.$alert.show(error);
            });
      } else {
        this.$patch(
            URL_UPDATE_LICENSE + this.items.current.data.id,
            toRequestObj(this.items.current.data),
            true
        )
            .then((result) => {
              let was_wild = this.was_wild;
              this._set_current(result, true);

              // Есть ли звездочка в сохраненной лицензии?
              let is_wild = result.connections.find(c => c.entities.find((e) => findEntityType(e).wild)) != undefined;

              // Удаление звездочки востанавливает триал, сообщим об этом
              if (was_wild && !is_wild && isNonPersonalTrial(result)) {
                this.$bvModal.msgBoxOk(this.$t('license.saving.trial_is_back.msg'),
                    msgBoxOptions(this.$t('license.saving.trial_is_back.h'), "primary")
                )
                    .then({})
                    .catch({})
              }


            })
            .catch((error) => {
              this.$alert.show(error);
            });
      }
    },

    _set_current: function (
        item,
        keepExistedNames = false /*, replace = false, back = false*/
    ) {
      this.$set(
          this.items,
          "current",
          licenseObject.init(item, keepExistedNames)
      );
      this.items.selected = item.id;

      // Есть ли звездочка в лицензии?
      this.was_wild = this.items.current.data.connections.find(c => c.entities.find((e) => findEntityType(e).wild)) != undefined;
    },
    _set_current_by_id: function (item_id) {
      let found = this.items.all.find((i) => i.id == item_id);
      if (found) this._set_current(found);
    },
    _update_all: function (list) {
      this.$set(this.items, "all", list);
      this.$set(this.items, "sortedList", this.arrangeLicenses(list));
    },
    _inject_existed_new: function (list, obj = null) {
      let created = licenseObject.initData(obj);
      let same_id_idx = list.findIndex((i) => i.id == created.id);
      if (same_id_idx >= 0) {
        list[same_id_idx] = created;
      } else {
        list.push(created);
      }

      return created;
    },
    addOrReplaceNew: function () {
      // Если текущая не сохранялась, позже удалим ее
      let delete_id = null;
      if (this.items.current.data._new) delete_id = this.items.current.data.id;

      let created = this._inject_existed_new(this.items.all);
      this._update_all(this.items.all);

      if (delete_id) this.removeItemById(delete_id);

      this.$nextTick(function () {
        // Обновление названия выбранного в навигации обновляется только так.
        this._update_all(this.items.all);
        this._set_current(created);
        this.navigateToId(UNSAVED_LICENSE_ID + created.id);
      });
    },
    removeItemById: function (item_id, update = false) {
      let idx = this.items.all.findIndex((i) => i.id == item_id);
      if (idx) {
        this.items.all.splice(idx, 1);
        if (update) this._update_all(this.items.all);
      }
    },

    loadOne: function (license_id, keepPath = false) {
      this.$get(URL_LOAD_LICENSE + license_id, true)
          .then((result) => {
            this._set_current(result);
            if (!keepPath) this.navigateToId(license_id);
          })
          .catch((error) => {
            this.$alert.show(error);
          });
    },

    loadList: function (current_id = null) {
      this.$get(URL_LOAD_LICENSE, true)
          .then((result) => {
            let new_cur = null;
            //let replace = false;
            if (current_id.startsWith(UNSAVED_LICENSE_ID)) {
              new_cur = this._inject_existed_new(
                  result,
                  licenseObject.initData(null, this.special)
              );
              //replace = true;
            } else {
              new_cur = result.find((item) => item.id == current_id);
              if (!new_cur) {
                // Такой лицензии нет на сервере, она либо удалена, либо никогда не было
                this.$router.replace({
                  name: "rdbmList",
                  params: {
                    message: "",
                  },
                });
              }
            }
            this._update_all(result);
            if (new_cur) this._set_current(new_cur /*, replace*/);

            // Корпоративу звездочки закинем только здесь, чтобы сделать его измененным.
            if (this.special && this.special.type == 'enterprise') {
              this.items.current.data.connections[0].entities[0].name = WILDCARD;
              this.items.current.data.connections[0].entities[1].name = WILDCARD;
              this.items.current.validate();
            }

            // Сообщение об успешной оплате
            if (this.action == "success") {
              this.$nextTick(function () {
                this.$bvModal.show("payment-ok-modal");
              });
            }

            // Сообщение об отмененной оплате
            if (this.action == "canceled") {
              this.$nextTick(function () {
                this.$bvModal.show("payment-cancel-modal");
              });
            }
          })
          .catch((error) => {
            this.$alert.show(error);
            return [];
          });
    },
  },
  beforeRouteLeave(to, from, next) {
    // Здесь можно прерывать покидание страницы вызовом next(false)
    next();
  },
  beforeRouteUpdate(to, from, next) {
    let id = to.params.id.startsWith(UNSAVED_LICENSE_ID)
        ? to.params.id.replace(UNSAVED_LICENSE_ID, "")
        : to.params.id;
    if (isUnsavedId(id)) {
      this.loadList(this.id);
    } else if (!this.doNotLoadItem) {
      this.loadOne(id, true);
    }
    next();
  },
  mounted: function () {
    this.$nextTick(function () {
      if (this.extLicenses) {
        this._update_all(this.extLicenses);
      } else {
        this.loadList(this.id);
      }
    });
  },
};

function msgBoxOptions(title, okVariant = "danger") {
  return {
    title,
    okVariant: okVariant,
    okTitle: i18n.t("button.yes"),
    cancelTitle: i18n.t("button.no"),
    footerClass: "p-2",
    hideHeaderClose: false,
    centered: true,
    bodyClass: "nice-modal"
  };
}
</script>

<style scoped>
@media screen and (max-width: 767px) {
  .licenses-nav {
    border-bottom: var(--default-border);
  }
}

.editor .nav-link,
.editor .navbar-text {
  padding: 0.3em 0.3em 0.3em 0;
  display: inline-block;
}

.editor .nav-item:not(:last-child)::after {
  content: "/";
  padding: 0.3em;
  display: inline-block;
}

.editor .dropdown-toggle {
  color: #1d1d1f;
}

.editor .group-name {
  font-size: 90%;
  opacity: 0.75;
}

#action-bar {
  background-color: var(--panel-bg-color);
}

.history {
  background-color: ivory;
}

#license-id {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
}

.license-actions {
  display: flex;
}

.separator {
  flex-grow: 4;
}

.total-price {
  display: grid;
  grid-template-columns: auto 5em;
}

@media screen and (min-width: 576px) {
  .license-actions button svg {
    margin-right: 0.25rem;
  }

  .save-icon-group {
    margin-right: 2rem !important;
  }
}

@media screen and (min-width: 767px) {
}

@media screen and (max-width: 576px) {
  .license-actions .text {
    display: none;
  }
}

#trial-note .icon {
  width: 4rem;
  margin-right: 1rem;
  color: #3cb1ff;
}
</style>